











import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
@Component({})
export default class Search extends Vue {
  keyword: string = ''

  @Prop()
  search!: string

  @Watch('search')
  handleSearchChange(val: string) {
    this.keyword = val
  }

  handleInput() {
    this.$emit('input', this.keyword)
  }

  handleSearch() {
    this.$emit('search')
    return false
  }

  handleCancel() {
    this.$emit('cancelSearch')
  }
}
